/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Show a "please wait" modal while a `.form-loader` form submits, close it on
 * submit-end. The disconnect also closes the modal, so a form swapped out by
 * Turbo mid-submit doesn't leave the modal stuck open.
 *
 * @type {Listener}
 */
export default {
    selector: 'form.form-loader',
    connect(element, { app }) {
        /** @type {ModalManager | null} */
        let modalManager = null

        const closeModalManager = () => {
            modalManager?.close()
        }

        const startModalManager = () => {
            modalManager ??= app.get('modalManager')
            modalManager.waiting('', 'Please wait...')
        }

        element.addEventListener('submit', startModalManager)
        element.addEventListener('turbo:submit-start', startModalManager)
        element.addEventListener('turbo:submit-end', closeModalManager)

        return () => {
            closeModalManager()
            element.removeEventListener('submit', startModalManager)
            element.removeEventListener('turbo:submit-start', startModalManager)
            element.removeEventListener('turbo:submit-end', closeModalManager)
        }
    },
}
